module.exports = __webpack_public_path__ + "img/impactoE4.37a4dfa0.png";